import { loadJSON } from "../hoi/animations/snkrs-calendar/js/tsunami/load/loadJSON";
import { Drops } from "../hoi/animations/snkrs-calendar/js/snkrs_cal/model/Drop";
import { Stories } from "../hoi/animations/snkrs-calendar/js/snkrs_cal/model/Story";
import dayjs from "dayjs";

const proxyURL = "https://nike-proxy-api.staging.enjoytheweather.com/";
const apiURLInStock = (marketplace, language) => `https://api.nike.com/product_feed/threads/v2/?anchor=0&count=48&filter=marketplace(${marketplace})&filter=language(${language})&filter=inStock(true)&filter=productInfo.merchPrice.discounted(false)&filter=channelId(010794e5-35fe-4e32-aaff-cd2c74f89d61)&filter=exclusiveAccess(true,false)&fields=active,id,lastFetchTime,productInfo,publishedContent.nodes,publishedContent.subType,publishedContent.properties.coverCard,publishedContent.properties.productCard,publishedContent.properties.products,publishedContent.properties.publish.collections,publishedContent.properties.relatedThreads,publishedContent.properties.seo,publishedContent.properties.threadType,publishedContent.properties.custom,publishedContent.properties.title`;
const apiURLUpcoming = (marketplace, language) => `https://api.nike.com/product_feed/threads/v2/?anchor=0&count=48&filter=marketplace(${marketplace})&filter=language(${language})&filter=upcoming(true)&filter=channelId(010794e5-35fe-4e32-aaff-cd2c74f89d61)&filter=exclusiveAccess(true,false)&sort=effectiveStartSellDateAsc&fields=active,id,lastFetchTime,productInfo,publishedContent.nodes,publishedContent.subType,publishedContent.properties.coverCard,publishedContent.properties.productCard,publishedContent.properties.products,publishedContent.properties.publish.collections,publishedContent.properties.relatedThreads,publishedContent.properties.seo,publishedContent.properties.threadType,publishedContent.properties.custom,publishedContent.properties.title`;
const apiURLStories = (marketplace, language) => `https://api.nike.com/product_feed/threads/v2/?anchor=0&count=48&filter=marketplace(${marketplace})&filter=language(${language})&filter=publishedContent.subType(story_format)&filter=channelId(010794e5-35fe-4e32-aaff-cd2c74f89d61)`;

const dropsURL = (marketplace, language) => `${proxyURL}${encodeURIComponent(apiURLUpcoming(marketplace, language))}`;
const inStockURL = (marketplace, language) => `${proxyURL}${encodeURIComponent(apiURLInStock(marketplace, language))}`;
const storiesURL = (marketplace, language) => `${proxyURL}${encodeURIComponent(apiURLStories(marketplace, language))}`;

export const SNKRS_CAL_CONFIG = {
    FR: {
        marketplace: "FR",
        language: "fr",
    },
    US: {
        marketplace: "US",
        language: "en",
        launchUrl: "https://www.nike.com/launch/t/",
        fallbackUrl: "https://www.nike.com/nike-app",
    },
    GB: {
        marketplace: "GB",
        language: "en-GB",
        launchUrl: "https://www.nike.com/launch/t/",
        fallbackUrl: "https://www.nike.com/nike-app",
    },
    IT: {
        marketplace: "IT",
        language: "it",
        launchUrl: "https://www.nike.com/it/launch/t/",
        fallbackUrl: "https://www.nike.com/nike-app",
    },
    JP: {
        marketplace: "JP",
        language: "ja",
        launchUrl: "https://www.nike.com/jp/launch/t/",
        fallbackUrl: "https://www.nike.com/nike-app",
        includeInactive: true,
    },
    CN: {
        marketplace: "CN",
        language: "zh-Hans",
        launchUrl: "https://www.nike.com.cn/snkrs-app",
        fallbackUrl: "https://www.nike.com.cn/snkrs-app",
    },
    KR: {
        marketplace: "KR",
        language: "ko",
        launchUrl: "https://www.nike.com/kr/en/launch",
        fallbackUrl: "https://www.nike.com/nike-app",
    },
};

export function fetchDrops({
    inStock,
    marketplace,
    language,
    includeInactive,
    onComplete,
    filterTests = true,
    onlyJordan = false,
    onlyFootwear = true,
}) {
    return loadJSON(dropsURL(marketplace, language)).then((dropsJson) => {
        let inStockPromise = Promise.resolve();
        let drops = Drops.fromJSON(dropsJson.objects, undefined, { includeInactive });
        let loadInStock = drops.length < 1;
        let inStockDrops;
        let jordanDrops;
        let jordanInStockDrops;

        const filterOnlyFootwear = (inputDrops) => onlyFootwear ? inputDrops.filter(({ isFootwear }) => isFootwear) : inputDrops;

        if (inStock == "true") {
            loadInStock = true;
        }

        if (loadInStock && !onlyJordan) {
            inStockPromise = loadJSON(inStockURL(marketplace, language)).then((inStockJson) => {
                drops = Drops.fromJSON(inStockJson.objects).filter(({ title, subtitle, fulltitle }) => {
                    if (!filterTests) {
                        return true;
                    }

                    const fields = [title, subtitle, fulltitle];
                    return !fields.some(i => i?.toLowerCase()?.includes("test"));
                });
                drops = filterOnlyFootwear(drops);
                drops.forEach((drop) => {
                    drop.inStock = true;
                });
                onComplete({
                    drops,
                    inStockMode: true,
                });
            });
        } else if (onlyJordan) {
            inStockPromise = loadJSON(inStockURL(marketplace, language)).then((inStockJson) => {
                inStockDrops = Drops.fromJSON(inStockJson.objects).filter(({ title, subtitle, fulltitle }) => {
                    if (!filterTests) {
                        return true;
                    }

                    const fields = [title, subtitle, fulltitle];
                    return !fields.some(i => i?.toLowerCase()?.includes("test"));
                });
                jordanDrops = drops.filter(({ brand }) => brand === "Jordan");
                jordanInStockDrops = inStockDrops.filter(({ brand }) => brand === "Jordan");

                if (jordanDrops.length < 6) {
                    jordanDrops.push(...jordanInStockDrops);
                    drops = jordanDrops;
                } else {
                    drops = jordanDrops;
                }
                drops = filterOnlyFootwear(drops);
                drops.forEach((drop) => {
                    drop.inStock = true;
                });
                onComplete({
                    drops,
                    inStockMode: true,
                });
            });
        } else {
            onComplete({
                drops: filterOnlyFootwear(drops),
                inStockMode: false,
            });
        }

        return inStockPromise.then(() => {
            return Drops.loadImages(drops);
        });
    });
}

export function fetchStories({ marketplace, language, onComplete, onlyJordan = true, include_videos = false, includes }) {
    return loadJSON(storiesURL(marketplace, language)).then((dropsJson) => {
        const drops = Stories.fromJSON(dropsJson.objects, includes)
            .filter(({ isJordan }) => onlyJordan ? isJordan : true)
            .filter((drop) => {
                if (include_videos) {
                    return true;
                }

                return drop.images.find(image => image.subType === "image");
            });

        onComplete({
            drops,
            inStockMode: false,
        });

        return Stories.loadImages(drops);
    });
}

export function splitByTimeframe(drops) {
    const endOfDay = dayjs().endOf("day");
    const startOfDay = dayjs().startOf("day");
    const split = {
        upcoming: [],
        today: [],
        past: [],
    };

    drops.forEach((drop) => {
        if (endOfDay.isBefore(dayjs(drop.startEntryDate))) {
            split.upcoming.push({ ...drop });
        } else if (startOfDay.isBefore(dayjs(drop.startEntryDate))) {
            split.today.push({ ...drop });
        } else {
            split.past.push({ ...drop });
        }
    });

    return split;
}
